module.exports = __webpack_public_path__ + "static/media/mdi_folder_.cbcb9091.svg";